import PageContentWrapper from '../../components/PageContentWrapper/PageContentWrapper';
import CardContainer from '../../components/CardContainer/CardContainer';
import { useMediaQuery } from 'src/hooks/useMediaQuery';
import { clsx } from 'clsx';
import { useParams } from 'react-router-dom';
import { useGetProjectByIdQuery } from 'src/services';
import { AddIntegrationPopup } from 'src/components/Integrations/AddIntegrationPopup/AddIntegrationPopup';
import { IntegrationsList } from 'src/components/Integrations/IntegrationsList/IntegrationsList';
import { getIntegrationCatalog } from 'src/components/Integrations/IntegrationTypes';
import { useAppSelector } from 'src/store';

const IntegrationsPage = () => {
  const isLgDown = useMediaQuery('(max-width: 992px)');
  const { id } = useParams();
  const { projectType } = useAppSelector((s) => s.projectsSlices);
  const { data: currentProject, isFetching: isFetchingProject } = useGetProjectByIdQuery({
    id: id,
  });
  const integrationTypes = getIntegrationCatalog(projectType);

  // True while the catalog still has an integration type the project has not added.
  const isAddIntegrationAvailable =
    (integrationTypes?.filter(
      (type) =>
        !currentProject?.integrations.some(
          (integration) => integration.integration_type === type.data.integration_type,
        ),
    ).length ?? 0) > 0;

  return (
    <PageContentWrapper className={clsx('knowledge-base-page-container', !isLgDown && 'relative')}>
      <div className="z-10 gap-[10px] flex flex-col relative">
        <CardContainer className="integration">
          <div className="card-header">
            <div className="title">
              <span>Integrations</span>
            </div>
            <div className="add-button-container">
              {Boolean(currentProject) && isAddIntegrationAvailable && (
                <AddIntegrationPopup project={currentProject} />
              )}
            </div>
          </div>
          <div className="card-body">
            <IntegrationsList
              isFetchingProject={isFetchingProject}
              isEmpty={!currentProject?.integrations?.length}
              integrations={currentProject?.integrations}
              integrationTypes={integrationTypes}
            />
          </div>
        </CardContainer>
      </div>
    </PageContentWrapper>
  );
};

export default IntegrationsPage;
